import React from "react";
import { Checkbox, Form, FormInstance, Input, Select, Typography } from "antd";
import { ILocationData } from "store/location/location-model";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "../index.styled";
import { accessPointOptionsReader, selectReaderModelList } from "../types";
import { updateAntennasByModel } from "./utils";

export interface IPropsFormReader {
  formReader: FormInstance;
  formAntenna: FormInstance;
  locationActiveList: ILocationData[];
}

interface IDispatchProps {
  readersUpdateFormReader: (...args) => void;
  readersUpdateFormAntenna: (...args) => void;
}

export type IFormProps = IPropsFormReader & IDispatchProps;

const FormReader = ({ formReader, formAntenna, locationActiveList, readersUpdateFormReader, readersUpdateFormAntenna }: IFormProps) => {
  const { Title } = Typography;

  const SELECT_A_UNIT = useTranslation({ id: "select_a_unit" });
  const SELECT_A_READER_NAME = useTranslation({ id: "select_a_reader_name" });
  const SELECT_READER_MODEL = useTranslation({ id: "select_reader_model" });
  const REQUIRED_FIELD = useTranslation({ id: "required_field" });

  return (
    <Form style={S.FormLayout} layout={"vertical"} form={formReader} onValuesChange={(_, allValues) => readersUpdateFormReader(allValues)}>
      <S.LayoutForm>
        <S.FormItem
          name="locationId"
          label={`${useTranslation({ id: "unit" })}*`}
          rules={[
            {
              required: true,
              message: REQUIRED_FIELD,
            },
          ]}
        >
          <Select size="large" placeholder={SELECT_A_UNIT} style={S.SelectField} data-testid="select-option">
            {locationActiveList?.length > 0 &&
              locationActiveList.map((option) => (
                <Select.Option value={option.id} key={`location-${option.id}-${option.description}`}>
                  {option.description}
                </Select.Option>
              ))}
          </Select>
        </S.FormItem>

        <S.FormItem
          name="readerNumber"
          label={`${useTranslation({ id: "reader_number" })}*`}
          rules={[
            {
              required: true,
              message: REQUIRED_FIELD,
            },
          ]}
        >
          <Input style={S.InputField} data-testid="readerNumber" maxLength={10} />
        </S.FormItem>

        <S.FormItem
          name="readerPositionType"
          label={`${useTranslation({ id: "reader_name" })}*`}
          rules={[
            {
              required: true,
              message: REQUIRED_FIELD,
            },
          ]}
        >
          <Select
            size="large"
            placeholder={SELECT_A_READER_NAME}
            style={S.SelectField}
            data-testid="selectReaderName"
            onChange={(modelId) =>
              updateAntennasByModel({
                modelId,
                accessPointOptionsReader,
                formAntenna,
                readersUpdateFormAntenna,
              })
            }
          >
            {accessPointOptionsReader.map((option) => (
              <Select.Option value={option.id} key={`reader-position-${option.id}-${option.description}`}>
                {option.description}
              </Select.Option>
            ))}
          </Select>
        </S.FormItem>

        <S.FormItem
          name="modelType"
          label={`${useTranslation({ id: "model" })}*`}
          rules={[
            {
              required: true,
              message: REQUIRED_FIELD,
            },
          ]}
        >
          <Select size="large" placeholder={SELECT_READER_MODEL} style={S.SelectField} data-testid="selectReaderModel">
            {selectReaderModelList.map((option) => (
              <Select.Option value={option.id} key={`reader-model-${option.id}-${option.description}`}>
                {option.description}
              </Select.Option>
            ))}
          </Select>
        </S.FormItem>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
          <S.FormItem
            name="readerIp"
            label={`${useTranslation({ id: "reader_ip" })}*`}
            rules={[
              {
                required: true,
                message: REQUIRED_FIELD,
              },
            ]}
          >
            <Input style={S.InputField} data-testid="readerIp" maxLength={45} />
          </S.FormItem>

          <S.FormItem
            name="configId"
            label={`${useTranslation({ id: "config_id" })}*`}
            rules={[
              {
                required: true,
                message: REQUIRED_FIELD,
              },
            ]}
          >
            <Input style={S.InputField} data-testid="configId" maxLength={50} />
          </S.FormItem>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>
          <S.FormItem
            name="port"
            label={`${useTranslation({ id: "port" })}*`}
            rules={[
              {
                required: true,
                message: REQUIRED_FIELD,
              },
            ]}
          >
            <Input style={S.InputField} data-testid="port" maxLength={10} />
          </S.FormItem>

          <S.FormItem
            name="protocol"
            label={`${useTranslation({ id: "protocol" })}*`}
            rules={[
              {
                required: true,
                message: REQUIRED_FIELD,
              },
            ]}
          >
            <Input style={S.InputField} data-testid="protocol" maxLength={50} />
          </S.FormItem>
        </div>

        <S.EventsContainer>
          <div>
            <S.FormCheckbox name="status" valuePropName="checked">
              <Checkbox data-testid="tagActive" />
            </S.FormCheckbox>
            <Title level={5} style={S.CheckDescription}>
              {useTranslation({ id: "active" })}
            </Title>
          </div>
        </S.EventsContainer>
      </S.LayoutForm>
    </Form>
  );
};

export default FormReader;
